import React, { useState, useEffect } from "react";
import { getInvoice } from "../../../services/finance/invoice";
import InvoiceList from "./invoice/invoiceList";
import IncomingInvoiceList from "./incomingInvoice/incomingInvoiceList";
import { PageSubHeader } from "../../../../provider/PageDataProvider";
import DialogLayout from "../../../partials/content/DialogLayout";
import { Card } from "react-bootstrap";
import { useGlobalData } from "../../../../provider/GlobalDataProvider";
function Invoice({ match, history }) {
  const { reload } = useGlobalData();
  let openInvoiceStream = true;
  let invoiceStreamParam = "";
  const urlSplit = match.url.split("/");
  invoiceStreamParam = urlSplit[3];
  if (invoiceStreamParam === "-") {
    openInvoiceStream = true;
  } else {
    openInvoiceStream = false;
  }
  const [openInvoicesStream, setOpenInvoicesStream] = useState(
    openInvoiceStream
  );
  const [invoiceStream, setInvoiceStream] = useState(invoiceStreamParam);
  const [auth, setAuth] = useState({ create: false });
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
  ];
  if (auth.create) {
    if (invoiceStream === "AR") {
      actionButtons.push({
        title: "Switch To A/P",
        color: "label-dark",
        icon: "fas fa-exchange-alt",
        onClick: () => {
          setInvoiceStream("AP");
          setOpenInvoicesStream(false);
          history.push("/finance/invoices/AP");
        },
      });
      actionButtons.push({
        title: "New A/R Invoice",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          history.push("/finance/create-invoice");
        },
      });
    } else if (invoiceStream === "AP") {
      actionButtons.push({
        title: "Switch To A/R",
        color: "label-dark",
        icon: "fas fa-exchange-alt",
        onClick: () => {
          setInvoiceStream("AR");
          setOpenInvoicesStream(false);
          history.push("/finance/invoices/AR");
        },
      });
      actionButtons.push({
        title: "New A/P Invoice",
        color: "primary",
        icon: "fas fa-plus-circle",
        onClick: () => {
          history.push("/finance/create-incoming-invoice");
        },
      });
    }
  }
  useEffect(() => {
    async function getInvoiceData() {
      const response = await getInvoice();
      const { data, auth } = response.data;
      setAuth(auth);
    }
    getInvoiceData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={
          invoiceStream === "AR"
            ? "Accounts Receivable Invoice List"
            : invoiceStream === "AP"
            ? "Accounts Payable Invoice List"
            : "Invoice List"
        }
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: `${
              invoiceStream === "AR"
                ? "/finance/invoices/AR"
                : invoiceStream === "AP"
                ? "/finance/invoices/AP"
                : "/finance/invoices/-"
            }`,
            title: `${
              invoiceStream === "AR"
                ? "A/R Invoices"
                : invoiceStream === "AP"
                ? "A/P Invoices"
                : "Select Invoice Stream"
            }`,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      {invoiceStream === "AR" ? (
        <InvoiceList history={history} />
      ) : invoiceStream === "AP" ? (
        <IncomingInvoiceList history={history} />
      ) : null}
      <DialogLayout
        open={openInvoicesStream}
        title="Select Invoice Stream"
        onCloseDialog={() => {}}
        maxWIdth="md"
      >
        <div className="row menu-row-modules mt-4">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setInvoiceStream("AR");
                  setOpenInvoicesStream(false);
                  history.push("/finance/invoices/AR");
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">
                    Accounts Receivable Invoices
                  </div>
                  <i className="fas fa-file-invoice-dollar fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setInvoiceStream("AP");
                  setOpenInvoicesStream(false);
                  history.push("/finance/invoices/AP");
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">
                    Accounts Payable Invoices
                  </div>
                  <i className="fas fa-file-invoice fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </DialogLayout>
    </React.Fragment>
  );
}

export default Invoice;
